import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core'
import { TuiBadge, TuiSkeleton } from '@taiga-ui/kit'
import { TranslatePipe } from '@ngx-translate/core'
import { PricePipe } from '@shared/pipes/price.pipe'
import { LiveTickerOrderBookInterface } from '@modules/stocks-module/live-ticker/interfaces/live-ticker-order-book.interface'
import { AnimatedNumberDirective } from '@shared/directives/animated-number/animated-number.directive'
import { PercentPipe } from '@shared/pipes/percent.pipe'

@Component({
	selector: 'app-order-book-linear',
	templateUrl: './order-book-linear.component.html',
	styleUrl: './order-book-linear.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TuiBadge, TuiSkeleton, TranslatePipe, PricePipe, AnimatedNumberDirective, PercentPipe],
})
export class OrderBookLinearComponent {
	public orderBook: InputSignal<LiveTickerOrderBookInterface | null | undefined> = input<
		LiveTickerOrderBookInterface | null | undefined
	>(null)
	public isLoading: InputSignal<boolean> = input<boolean>(false)

	protected totalBidAskSize: Signal<number> = computed<number>((): number => {
		const orderBook: LiveTickerOrderBookInterface | null | undefined = this.orderBook()
		if (!orderBook) return 0
		return orderBook.bidSize + orderBook.askSize
	})

	protected percentAskSize: Signal<number> = computed<number>((): number => {
		const orderBook: LiveTickerOrderBookInterface | null | undefined = this.orderBook()
		if (!orderBook) return 0
		const totalBidAskSize: number = this.totalBidAskSize()
		return (orderBook.askSize / totalBidAskSize) * 100
	})

	protected percentBidSize: Signal<number> = computed<number>((): number => {
		const orderBook: LiveTickerOrderBookInterface | null | undefined = this.orderBook()
		if (!orderBook) return 0
		const totalBidAskSize: number = this.totalBidAskSize()
		return (orderBook.bidSize / totalBidAskSize) * 100
	})
}
